import { FEATURES } from '@constants/Text'
import * as commercialStore from './store'

export function commercialModule({ store }) {
  store.registerModule('commercial', {
    ...commercialStore,
    namespaced: true,
  })
}

export const PERMISSION = FEATURES.IA_SDR
